/* eslint-disable @typescript-eslint/restrict-template-expressions */
import styled from 'styled-components'
import { ResponsivePicture } from '../ResponsivePicture/ResponsivePicture'

export const Container = styled.div<{
  hasShadow?: boolean
  offsetHeight?: number
}>`
  position: relative;
  width: 100%;
  height: 57rem;

  @media (min-width: 768px) {
    height: 75rem;
  }

  @media (min-width: 992px) {
    height: 63rem;
  }

  @media (min-width: 1200px) {
    height: 98vh;
  }

  ${({ hasShadow, offsetHeight }) => {
    return (
      hasShadow !== false &&
      `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      display: block;
      height: ${offsetHeight ?? 0}px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      z-index: 1;
    }`
    )
  }}
`

export const Picture = styled(ResponsivePicture)`
  object-fit: cover;
  width: 100%;
  height: 100%;
`

export const ScrollDown = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 1;
`
